
import genesysCloud from '@/services/genesyscloud-service'
import AppHeader from '@/components/AppHeader.vue'
import config from '@/config/config'

export default {
  name: 'Agent Monitoring App',
  components: {
    AppHeader
  },
  async created (): Promise<void> {
    await genesysCloud.loginImplicitGrant()
    history.pushState({}, '', config.redirectUri)
  }
}
